import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '../config/config.service';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgForm, UntypedFormControl, Validators, UntypedFormGroup} from '@angular/forms';
import {LanguageService} from '../service/language.service';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RegisterComponent implements OnInit {

  constructor(private router: Router, private api: ConfigService, private translate: TranslateService,
              // tslint:disable-next-line:variable-name
              private snackBar: MatSnackBar, private _language: LanguageService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }

  // role id = 1 => buyer
  // role id = 2 => wannabeartist
  // role id = 3 => artist
  errorMessage = '';
  hidePassword = true;
  hideConfirmPassword = true;
  isLoaderVisible = false;

  registerForm = new UntypedFormGroup({
    registerEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
    registerPhone: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    registerFirstName: new UntypedFormControl('', [Validators.required]),
    registerLastName: new UntypedFormControl('', [Validators.required]),
    registerAccountType: new UntypedFormControl('', [Validators.required]),
    registerPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(10)]),
    registerConfirmPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(10)]),
    registerTermsAndConditions: new UntypedFormControl('', [Validators.required, Validators.requiredTrue]),
    registerPersonalData: new UntypedFormControl('', [Validators.required, Validators.requiredTrue]),
  });

  // tslint:disable-next-line:typedef
  get registerEmailFormControl() {
    return this.registerForm.get('registerEmail') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerPhoneFormControl() {
    return this.registerForm.get('registerPhone') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerFirstNameFormControl() {
    return this.registerForm.get('registerFirstName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerLastNameFormControl() {
    return this.registerForm.get('registerLastName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerAccountTypeFormControl() {
    return this.registerForm.get('registerAccountType') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerPasswordFormControl() {
    return this.registerForm.get('registerPassword') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerConfirmPasswordFormControl() {
    return this.registerForm.get('registerConfirmPassword') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerTermsAndConditionsFormControl() {
    return this.registerForm.get('registerTermsAndConditions') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get registerPersonalDataFormControl() {
    return this.registerForm.get('registerPersonalData') as UntypedFormControl;
  }

  checkRegister(): void {
    if (this.registerPasswordFormControl.value === this.registerConfirmPasswordFormControl.value){
      this.errorMessage = '';
      this.submitRegister();
    } else {
      this.translate.get('passwordsMustBeIdentical').subscribe(message => {
        this.errorMessage = message;
        this.snackBar.open(message, '',
          {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
        return false;
      });
    }
  }

  submitRegister(): void {
    this.isLoaderVisible = true;
    const firstName =  this.registerFirstNameFormControl.value;
    const lastName = this.registerLastNameFormControl.value;
    const email = this.registerEmailFormControl.value;
    const phone = this.registerPhoneFormControl.value;
    const pass = this.registerPasswordFormControl.value;
    const confPass = this.registerConfirmPasswordFormControl.value;
    const accountType = this.registerAccountTypeFormControl.value;
    const termsAndConditions = this.registerTermsAndConditionsFormControl.value;
    const personalData = this.registerPersonalDataFormControl.value;
    let agreeData = 0;

    if (termsAndConditions === 1 &&  personalData === 1) {
      agreeData = 1;
    }

    console.log('acc type', typeof accountType);

    this.api.Register(firstName, lastName, pass, email, phone,
      agreeData, 1, 1, Number(accountType)).subscribe(async (data: any) => {
        this.errorMessage = '';
        if (Number(accountType) === 3) {
          await this.announceMeWannaBeArtist(firstName, lastName, email, phone);
        }
        this.isLoaderVisible = false;
        this.router.navigate(['Login']);
      },
      err => {
        this.translate.get('errorOccurred').subscribe(message => {
          this.isLoaderVisible = false;
          this.errorMessage = message;
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
        });
      });
  }

  announceMeWannaBeArtist(firstName: string, lastName: string, email: string, phone: string): void {
    // send email to me
    this.api.SendEmail(firstName + ' ' + lastName, email, 'tel: ' + phone +  ', vrea sa fie artist').subscribe(
      data => {
        console.log('data', data);
      },
      error => {
        this.translate.get('errorOccurred').subscribe(msg => {
          this.errorMessage = msg;
        });
      });
  }


  ngOnInit(): void {
  }
}
